import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';
import { TapIntoMagicProps } from './TapIntoMagic';

export const TapIntoMagicWrapper = styled.div<TapIntoMagicProps>`
  width: 100%;
  max-width: 100vw !important;
  background-color: ${({ backgroundColor }) => backgroundColor || palette.wheat};
`;

export const TapIntoMagicContainer = styled.div`
  max-width: 1328px !important;
  padding: 6rem 1.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  row-gap: 2.5rem;
  margin: 0 auto;

  @media screen and (max-width: ${layout.md}) {
    padding: 3rem 1.5rem;
  }
`;

export const TapIntoMagicText = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
  justify-content: flex-start;
  align-items: flex-start;

  @media screen and (max-width: ${layout.md}) {
    justify-content: center;
    align-items: center;
    max-width: 640px;
    margin: 0 auto;

    h1,
    p {
      text-align: center;
    }
  }
`;

export const DesktopContentWrapper = styled.div`
  width: 100%;
  display: block;

  @media screen and (max-width: ${layout.md}) {
    display: none;
  }
`;

export const MobileContentWrapper = styled.div`
  display: none;
  flex-direction: column;
  row-gap: 2.5rem;
  width: 100%;

  @media screen and (max-width: ${layout.md}) {
    display: flex;
  }
`;

export const MobileContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;

  .gatsby-image-wrapper {
    border-radius: 16px;
    overflow: hidden;
  }
`;
